import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { CanDeactivateGuard } from '../shared/guards/candeactivate.guard';
import { RouterModule } from '@angular/router';
import { StartUpModule } from './start-up/start-up.module';
import { StoreModule } from '@ngrx/store';
import { PermissionMappingReducer } from '../app-store/user/userPermission.reducer';
import { CountryAvailabilityComponent } from './country-availability/country-availability.component';
import { NavigationButtonsComponent } from './button/button.component';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    CoreModule,
    RouterModule,
    StartUpModule,
    StoreModule.forFeature('userPermissionMapping', PermissionMappingReducer)
  ],
  exports: [
    CoreModule,
  ],
  providers: [CanDeactivateGuard],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FeatureModule { }
